(function () {
  'use strict';

  angular.module('wsLrs.controllers').factory("BreadCrumbs", ['$location', '$route', 'User', function ($location, $route, User) {
    return {
      _list: null,
      add: function add(title, reset) {
        // Can optionally reset the bread crumb listing
        if (!!reset) {
          this._list.splice(0, this._list.length);
        }

        // Figure out the route associated with this location
        var path = $location.url();
        var thisRoute = _.findKey($route.routes, function (config, route) {
          return route === path || config.regexp && config.regexp.test(path);
        }) || path;
        var routeShouldResetCrumbs = thisRoute.indexOf('dashboard') >= 0 || thisRoute.indexOf('card-group') >= 0;

        // Figure out where this route is in the breadcrumbs (if at all)
        var routeIndex = _.indexOf(_.pluck(this._list, 'route'), thisRoute);
        var titleIndex = _.indexOf(_.pluck(this._list, 'title'), title);
        var breadCrumb = {
          route: thisRoute,
          title: title,
          href: "#" + path
        };

        // If this title already exists in the list of breadcrumbs,
        // then chop of everything after it and update it
        if (titleIndex >= 0) {
          this._list.splice(titleIndex + 1, this._list.length);
          _.extend(this._list[titleIndex], breadCrumb);

          // If this route already exists in the list of breadcrumbs,
          // then chop off everything it and update the crumb
        } else if (routeIndex >= 0 && routeShouldResetCrumbs) {
          this._list.splice(routeIndex + 1, this._list.length);
          _.extend(this._list[routeIndex], breadCrumb);

          // Otherwise, add it to the end...
        } else {
          this._list.push(breadCrumb);
        }
        this.save();
      },
      pop: function pop() {
        this._list.pop();
        this.save();
      },
      get: function get() {
        // if initial get(), retrieve the breadCrumb trail
        if (this._list === null) {
          this._list = [];
          var breadCrumbs = User.get().breadCrumbs;
          if (_.isArray(breadCrumbs)) {
            this._list = breadCrumbs;
          }
        }
        return this._list;
      },
      set: function set(list) {
        this._list = list;
        this.save();
      },
      // Save the breadCrumb trail
      save: function save() {
        var user = User.get();
        user.breadCrumbs = this._list;
        User.set(user);
      }
    };
  }]).
  /**
   * Breadcrumb
   **/
  controller('BreadCrumbCtrl', ['$scope', '$rootScope', 'BreadCrumbs', function ($scope, $rootScope, BreadCrumbs) {
    $scope.hide = true;
    $scope.breadCrumbs = BreadCrumbs.get();
    var topLevelTitles = ["Dashboard", "Your Reports", "Settings", "Admin"];
    var removeHeadlineChangeListener = $rootScope.$on("headline:change", function (evt, headline, clear) {
      if (clear) {
        //clear out and set reasonable defaults
        resetBreadCrumbs();
        BreadCrumbs.add(headline);
        $scope.breadCrumbs = BreadCrumbs.get();
        return;
      }
      $scope.hide = headline === "hide";
      if (!$scope.hide) {
        BreadCrumbs.add(headline, _.contains(topLevelTitles, headline));
      }
    });
    var resetBreadCrumbsListener = $rootScope.$on("headline:reset", function () {
      resetBreadCrumbs();
    });
    function resetBreadCrumbs() {
      BreadCrumbs.set([]);
      $scope.breadCrumbs = [];
    }
    $scope.$on('$destroy', function () {
      removeHeadlineChangeListener();
      resetBreadCrumbsListener();
    });
  }]);
})();
